import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { painelOficina } from '@/lib/painelOficina';

/** Rota legada: indicadores foram descontinuados no módulo oficina; redireciona para o Kanban. */
export const DashboardOficinaIndicadoresPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');
  return <Navigate to={painelOficina(companyId).kanbanHref} replace />;
};
